import React from 'react'
import Routers from '../routers/Routers.tsx'

const LayoutSection = () => {
  return (
   <main>
    <Routers/>
   </main>
  )
}

export default LayoutSection